import React, { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import singleBuildingImage from "../../assets/images/images/single-building.svg";
import multiBuildingImage from "../../assets/images/images/multi-building.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./viewBuildings.styles.css";
import { Button } from "components";
import ClipLoader from "react-spinners/ClipLoader";

import building from "../../assets/images/imageIcon/buildings-2.svg";
import next from "../../assets/images/imageIcon/next.svg";
import prev from "../../assets/images/imageIcon/prev.svg";

import { getImidServiceUrl } from "utils/api-util";
import { useSelector } from "react-redux";

function ViewBuildings() {
  const [buildings, setBuildings] = useState([]);
  const [activeTab, setActiveTab] = useState("all");
  const [page, setPage] = useState(0); // Pagination state
  const [loading, setLoading] = useState(false); // Loading state
  const token = window.localStorage.getItem("token");
  const user = useSelector((state) => state.auth.userData);
  console.log(user);

  const baseUrl = getImidServiceUrl();

  const navigate = useNavigate();

  // To get the props that was sent from the previous page
  const location = useLocation();

  const id = location?.state?.id;

  const queryParam = id ? `&customerId=${id}` : "";

  // '5ceecfd8-15b5-420d-865d-f8f2f593ae07'

  // console.log(`id: ${id}`)

  useEffect(() => {
    const url = `${baseUrl}/building?pageSize=6&page=${page}${queryParam}`;
    console.log(url);
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    setLoading(true); // Start loading
    fetch(url, { headers })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        console.log("Data:", data);
        if (Array.isArray(data.items)) {
          setBuildings(data.items);
        } else {
          setBuildings([]);
        }
      })
      .catch((error) => {
        console.error("There was an error fetching the buildings!", error);
      })
      .finally(() => {
        setLoading(false); // Stop loading
      });
  }, [token, page]); // Fetch data when token or page changes

  const filteredBuildings = Array.isArray(buildings)
    ? buildings.filter((building) => {
        if (activeTab === "all") return true;
        if (activeTab === "active") return building.status === "Active";
        if (activeTab === "inactive") return building.status === "Inactive";
        return false;
      })
    : [];

  const handleNextPage = () => {
    setPage((prevPage) => prevPage + 1);
  };

  const handlePreviousPage = () => {
    if (page > 0) {
      setPage((prevPage) => prevPage - 1);
    }
  };

  const createNewBuilding = () => {
    localStorage.setItem("createNewBuilding", true);
    localStorage.setItem("customerId", id);
    navigate("/imidbuilding");
  };

  return (
    <div className="mt-16">
      {user?.role === "ROLE_SUPER_ADMIN" && (
        <div className="my-3 cursor-pointer w-fit">
          <div className="flex items-center" onClick={() => navigate(-1)}>
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.7375 0H7.2625C2.7125 0 0 2.7125 0 7.2625V17.725C0 22.2875 2.7125 25 7.2625 25H17.725C22.275 25 24.9875 22.2875 24.9875 17.7375V7.2625C25 2.7125 22.2875 0 17.7375 0ZM20 13.4375H7.2625L11.025 17.2C11.3875 17.5625 11.3875 18.1625 11.025 18.525C10.8375 18.7125 10.6 18.8 10.3625 18.8C10.125 18.8 9.8875 18.7125 9.7 18.525L4.3375 13.1625C4.1625 12.9875 4.0625 12.75 4.0625 12.5C4.0625 12.25 4.1625 12.0125 4.3375 11.8375L9.7 6.475C10.0625 6.1125 10.6625 6.1125 11.025 6.475C11.3875 6.8375 11.3875 7.4375 11.025 7.8L7.2625 11.5625H20C20.5125 11.5625 20.9375 11.9875 20.9375 12.5C20.9375 13.0125 20.5125 13.4375 20 13.4375Z"
                fill="#808080"
              />
            </svg>
            <p className="ml-1">Back</p>
          </div>
        </div>
      )}

      <div className="tabs-container  mt-12">
        <div className="tabs">
          <button
            onClick={() => setActiveTab("all")}
            className={`tab ${activeTab === "all" ? "active" : ""}`}
          >
            All Buildings
          </button>
          <button
            disabled
            onClick={() => setActiveTab("active")}
            className={`tab ${activeTab === "active" ? "active" : ""}`}
          >
            Active Buildings
          </button>
          <button
            disabled
            onClick={() => setActiveTab("inactive")}
            className={`tab ${activeTab === "inactive" ? "active" : ""}`}
          >
            Inactive Buildings
          </button>
          {user?.role === "ROLE_SUPER_ADMIN" && (
            <div className="building-button justify-self-end">
              <Button
                onClick={createNewBuilding}
                className="add-building-button"
              >
                <img src={building} className="img-building" alt="building" />
                Add Building
              </Button>
            </div>
          )}
        </div>
      </div>

      {loading ? (
        <div className="flex items-center justify-center min-h-screen ml-56 mb-60">
          <ClipLoader color={"#123abc"} loading={loading} size={50} />
        </div>
      ) : (
        <div className="transactions">
          {filteredBuildings.length > 0 ? (
            <div className="grid grid-cols-3 gap-20 md:grid-cols-2 sm:grid-cols-1 sm:justify-items-center">
              {filteredBuildings.map((building) => (
                <div key={building.id} className="building">
                  <center>
                    <img
                      src={
                        building.numberOfApartments <= 5
                          ? singleBuildingImage
                          : multiBuildingImage
                      }
                      alt="building"
                    />
                  </center>
                  <div className="flex justify-between gap-4">
                    <div className="building-details">
                      <p className="text-left font-bold text-[10px] w-[100%]  pb-1">
                        Building ID
                      </p>
                      <p className="text-left font-bold text-[10px] pb-1">
                        Address
                      </p>
                      <p className="text-left font-bold text-[10px] pb-1">
                        City
                      </p>
                      <p className="text-left font-bold text-[10px] w-[100%] pb-1">
                        Number of Unit
                      </p>
                      <p className="text-left font-bold text-[10px]">
                        Contact{" "}
                      </p>
                    </div>
                    <div>
                      <p className="text-left font-bold text-[10px] pb-1">
                        {building.id}
                      </p>
                      <p className="text-left font-bold text-[10px] pb-1 w-[100%]">
                        {building.address}
                      </p>
                      <p className="text-left font-bold pb-1 text-[10px] ">
                        {building.city}
                      </p>
                      <p className="text-left font-bold pb-1 text-[10px] ">
                        {building.numberOfApartments}
                      </p>
                      <p className="text-left pb-1 font-bold text-[10px] ">
                        {building.contactName}
                      </p>
                    </div>
                  </div>
                  <br />
                  <Link
                    to={{
                      pathname: `/building/${building.id}/apartments`,
                    }}
                    state={building}
                  >
                    <center>
                      <div className="view-building-button">
                        <Button>View Details</Button>
                      </div>
                    </center>
                  </Link>
                </div>
              ))}
            </div>
          ) : (
            <div className="flex items-center justify-center min-h-screen ml-56 mb-60">
              <p className="font-bold text-xl">No buildings available.</p>
            </div>
          )}
        </div>
      )}
      {
        <div className="flex flex-row justify-end">
          <img
            className="arrow-tag"
            src={prev}
            alt="previous"
            onClick={handlePreviousPage}
            disabled={page === 0}
          />
          <div className="p-5">{page + 1}</div>
          <img
            className="arrow-tag"
            src={next}
            alt="next"
            onClick={handleNextPage}
          />
        </div>
      }
    </div>
  );
}

export default ViewBuildings;
